angular.module('impactx.catalog').directive('ixCatalogApprovalProcess', function ()
{
    return {
        scope: {
            catalog: "=",
            dialogData: "=",
            headerLabel: "=",
            trns: "="
        },
        restrict: 'E',
        templateUrl: 'modules/catalog/templates/catalogapprovalprocess.tmpl.html',
        transclude: true
    };
});